import { useState } from "react";
import { Button, Grid, TextField } from "@mui/material";
import { AddCircleOutline } from "@mui/icons-material";

import { topeSeriesManual, useCargarSeriesProductos, usaMetrosPorSerie } from "@/store/erp/productos/useCargarSeriesProductos.store";
import { OBSERVACION_SERIE_MAX } from "@/shared/utils";

///* Carga manual del reingreso: una serie por vez. Por metros se agregan
///* metros (obligatorio) y observacion (opcional); por cantidad, solo la serie.
export default function CargaManualSeries() {

  const auxRow = useCargarSeriesProductos(s => s.auxRow);
  const agregarSerieManual = useCargarSeriesProductos(s => s.agregarSerieManual);

  const [serieInput, setSerieInput] = useState<string>('');
  const [metrosInput, setMetrosInput] = useState<string>('');
  const [observacionInput, setObservacionInput] = useState<string>('');
  const [errorSerie, setErrorSerie] = useState<string>('');
  const [errorMetros, setErrorMetros] = useState<string>('');
  const [errorObservacion, setErrorObservacion] = useState<string>('');
  const [validando, setValidando] = useState<boolean>(false);

  const pideMetros = usaMetrosPorSerie(auxRow);

  const cargadas = auxRow?.series?.length ?? 0;
  const tope = topeSeriesManual(auxRow);
  const completo = tope > 0 && cargadas >= tope;

  const agregar = async () => {

    if (validando) return;
    setValidando(true);

    const resultado = await agregarSerieManual({
      serie: serieInput,
      metros: metrosInput,
      observacion: observacionInput,
    }).finally(() => setValidando(false));

    setErrorSerie(resultado.campo === 'serie' ? resultado.mensaje! : '');
    setErrorMetros(resultado.campo === 'metros' ? resultado.mensaje! : '');
    setErrorObservacion(resultado.campo === 'observacion' ? resultado.mensaje! : '');

    if (!resultado.ok) return;

    setSerieInput('');
    setMetrosInput('');
    setObservacionInput('');
  };

  ///* Enter agrega la fila sin disparar el submit del formulario padre.
  const handleEnter = (e: React.KeyboardEvent) => {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    agregar();
  };

  return (
    <Grid container spacing={1} alignItems="flex-start">

      <Grid item xs={12} sm={pideMetros ? 4 : 10}>
        <TextField
          fullWidth
          size="small"
          label="Serie"
          placeholder="Ej: ABC123"
          value={serieInput}
          disabled={completo}
          error={!!errorSerie}
          onChange={(e) => { setSerieInput(e.target.value); setErrorSerie(''); }}
          onKeyDown={handleEnter}
          helperText={errorSerie || (completo ? 'Se alcanzó la cantidad del producto.' : 'Solo letras y números, sin espacios ni símbolos.')}
          inputProps={{ style: { fontFamily: 'monospace' } }}
        />
      </Grid>

      {pideMetros && (
        <>
          <Grid item xs={12} sm={3}>
            <TextField
              fullWidth
              type="number"
              size="small"
              required
              label="Metros"
              placeholder="Ej: 250.50"
              value={metrosInput}
              disabled={completo}
              error={!!errorMetros}
              onChange={(e) => { setMetrosInput(e.target.value); setErrorMetros(''); }}
              onKeyDown={handleEnter}
              helperText={errorMetros || 'Metraje del carrete.'}
              inputProps={{ min: 0, step: '0.01' }}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <TextField
              fullWidth
              size="small"
              label="Observación"
              placeholder="Opcional"
              value={observacionInput}
              disabled={completo}
              error={!!errorObservacion}
              onChange={(e) => { setObservacionInput(e.target.value); setErrorObservacion(''); }}
              onKeyDown={handleEnter}
              helperText={errorObservacion || 'Opcional.'}
              inputProps={{ maxLength: OBSERVACION_SERIE_MAX }}
            />
          </Grid>
        </>
      )}

      <Grid item xs={12} sm={2}>
        <Button
          fullWidth
          variant="contained"
          size="small"
          style={{ color: 'white', background: 'black' }}
          disabled={completo || validando || !serieInput.trim() || (pideMetros && !metrosInput.trim())}
          startIcon={<AddCircleOutline />}
          onClick={agregar}
          sx={{ whiteSpace: 'nowrap', mt: 0.5 }}
        >
          {validando ? 'Validando...' : 'Agregar'}
        </Button>
      </Grid>

    </Grid>
  );
}
